

const commercialUseHandler = (event)=>{
    const input = event.currentTarget
    if (input.checked && input.value === 'yes') {
        fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ attributes: { 'For Commercial Use': 'yes' } })
        });
    } else if (input.checked && input.value === 'no') {
        fetch('/cart/update.js', {
            method: 'POST', 
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ attributes: { 'For Commercial Use': 'no' } })
        });
    }
    updateInputs(input.value)
}

const updateInputs = (value)=>{
    const inputs = document.querySelectorAll("input[name='commercial']") 
    inputs.forEach((input)=>{
        if(input.value == value){
            input.checked = true
        }
        else{
            input.checked = false
        }
    })
}






